import { render, staticRenderFns } from "./SharedAlbumContent.vue?vue&type=template&id=1681e6c1&scoped=true&"
import script from "./SharedAlbumContent.vue?vue&type=script&lang=js&"
export * from "./SharedAlbumContent.vue?vue&type=script&lang=js&"
import style0 from "./SharedAlbumContent.vue?vue&type=style&index=0&id=1681e6c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1681e6c1",
  null
  
)

export default component.exports